
class Menushow {
    getMenu = () => {
      var values = {
        "dmtShow":"yes",
        "billPayShow":"no",
        "rechargeShow":"yes",
        "payOutShow":"yes",
        "aepsShow":"yes",
        "kycShow":"yes"
      }
      return values;
    }
  
  }
  export default new Menushow();